import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'components/layout';

const ApplyButton = ({ id, showPriority, startDate }) => {
  switch (showPriority) {
    case 0:
      return (
        <>
          <Button style={{ float: 'right', marginTop: 'auto' }} type="primary">
            <Link
              to={`/project-applications/apply`}
              search={`?settingId=${id}`}
            >
              Apply now
            </Link>
          </Button>
        </>
      );
    case 1:
      return (
        <Button
          style={{ float: 'right', marginTop: 'auto' }}
          type="primary"
          disabled
        >
          Application start at: {moment(startDate).format('YYYY-MM-DD')}
        </Button>
      );
    case 2:
      return (
        <Button
          style={{ float: 'right', marginTop: 'auto' }}
          type="primary"
          disabled
        >
          Closed
        </Button>
      );
    default:
      return null;
  }
};

ApplyButton.propTypes = {
  id: PropTypes.string.isRequired,
  showPriority: PropTypes.number.isRequired,
  startDate: PropTypes.number.isRequired,
};

export default ApplyButton;
